import { render, staticRenderFns } from "./CheckSchool.vue?vue&type=template&id=84c760f8"
import script from "./CheckSchool.vue?vue&type=script&lang=js"
export * from "./CheckSchool.vue?vue&type=script&lang=js"
import style0 from "./CheckSchool.vue?vue&type=style&index=0&id=84c760f8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports